class Buttons {

    /**
     * @since 0.2.0
     * @method constructor
     */
    constructor() {
        // Run waterdrop animations
        this.pulse();
    }

    /**
     * Adds the ripple class when a clear button is clicked.
     *
     * @since 0.2.0
     * @method pulse
     * @return void
     */
    pulse() {
        // Declare and initialize
        let items      = $('.ripple');
        let clickClass = 'clicked';
        let dropper    = this.createDrop;

        // If we have none, do nothing
        if (!items.length)
            return;

        // Listen to them
        items.each((i, item) => {

            // Listen to it
            $(item).on('click', function (e) {

                // Run the dropper
                dropper(e, $(this));

            });

        });
    }

    /**
     * Create a little ripple on a button.
     *
     * @since 0.2.0
     * @method createDrop
     * @param object event is the click event
     * @param object parent is the parent element that was clicked
     * @return object The xy coordinates of mouse position
     */
    createDrop(event, parent) {
        // Declare and initialize
        let pulse   = $('<div class="pulse"></div>');
        let pos     = {x: event.offsetX, y: event.offsetY};
        let sign    = Math.random() < 0.5 ? -1 : 1;
        let degrees = Math.floor(Math.random() * (90 - 1));

        // Set the ripple location
        pulse.css('--x', pos.x + 'px');
        pulse.css('--y', pos.y + 'px');
        pulse.css('--rotate', (degrees * sign) + 'deg');

        // Add it to the parent
        parent.append(pulse);

        // Remove it after a while
        setTimeout(() => pulse.remove(), 2000);
    }
}

export default Buttons;